import { Avatar } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import styles from './LinkedContactItem.module.scss';
import { Props } from './LinkedContactItem.types';

const LinkedContactItem = ({ item, onClick }: Props) => {
  const { t } = useTranslation();

  const category = item.metadata?.category as string | undefined;
  const initials = item.title
    .split(' ')
    .map(part => part.charAt(0))
    .join('')
    .toUpperCase();

  return (
    <div className={styles.container} onClick={onClick}>
      <Avatar color="initials" name={initials} size="md" />
      <div className={styles.content}>
        <span className={styles.title}>{item.title}</span>
        {category && (
          <span className={styles.subtitle}>{t(`contacts.categories.${category}`, category)}</span>
        )}
      </div>
    </div>
  );
};

export default LinkedContactItem;
